import { BaseTooltipAction, TooltipState } from '../../types';
import { grammarValidationReducer } from './grammarValidationReducer';

export type GrammarSaveAction =
    | BaseTooltipAction
    | 'empty-required'
    | 'grammar-too-long'
    | 'duplicate-id'
    | 'size-exceed';

export const grammarSaveReducer = (state: TooltipState, action: GrammarSaveAction): TooltipState => {
    switch (action) {
        case 'grammar-too-long':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Не более 500 строк в грамматике',
                tooltipTheme: 'error',
            };
        case 'empty-required':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Заполнены не все обязательные поля',
                tooltipTheme: 'error',
            };
        case 'duplicate-id':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Интент с указанным ID уже существует',
                tooltipTheme: 'error',
            };
        case 'size-exceed':
            return {
                tooltipVisible: true,
                tooltipLabel: 'Размер скомпилированной грамматики не должен превышать 59000 символов',
                tooltipTheme: 'error',
            };
        default:
            return grammarValidationReducer(state, action);
    }
};
